<template>
  <div class="mt-2 w-full">
    <label
      class="block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
      >{{ label }}</label
    >
    <div class="mt-2 pl-2 py-2 pr-1 border border-gray-300 rounded-lg">
      <div v-if="!readonly" class="pr-1">
        <select
          class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-3 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500 cursor-pointer"
          ref="select"
          v-model="newIngredient"
          @click.stop
        >
          <option value="" disabled selected>Recipes</option>
          <option
            v-for="i in recipeIds.sort((a, b) => {
              const nameA = recipes[a] && recipes[a].name ? recipes[a].name : ''
              const nameB = recipes[b] && recipes[b].name ? recipes[b].name : ''
              return nameA.toLowerCase().localeCompare(nameB.toLowerCase())
            })"
            :key="`${i}-recipes`"
            :value="i"
          >
            {{
              `${
                recipes[i] && recipes[i].name ? recipes[i].name : 'Unknown'
              } (${
                recipes[i] && recipes[i].unitType ? recipes[i].unitType : '?'
              })`
            }}
          </option>
          <option value="" disabled selected>Products</option>
          <option
            v-for="i in productIdsActive.sort((a, b) => {
              const nameA =
                products[a] && products[a].name ? products[a].name : ''
              const nameB =
                products[b] && products[b].name ? products[b].name : ''
              return nameA.toLowerCase().localeCompare(nameB.toLowerCase())
            })"
            :key="`${i}-products`"
            :value="i"
          >
            {{
              `${
                products[i] && products[i].name ? products[i].name : 'Unknown'
              } (${
                products[i] && products[i].unitRecipe
                  ? products[i].unitRecipe
                  : '?'
              })`
            }}
          </option>
        </select>
        <div
          class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
        >
          <svg
            class="fill-current h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path
              d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
            />
          </svg>
        </div>
      </div>
      <div v-if="!readonly" class="mt-2 flex items-center">
        <input
          ref="input"
          class="py-2 px-3 focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          type="tel"
          autocomplete="off"
          @keypress.enter="add({ newIngredient, newAmount })"
          placeholder="Amount"
          v-model.trim="newAmount"
        />
        <button
          class="ml-1 p-2 text-base focus:outline-none focus:shadow-outline text-gray-600 hover:text-gray-900 bg-transparent hover:bg-gray-200 rounded-full h-10 w-12 flex items-center justify-center"
          @click.prevent="add({ newIngredient, newAmount })"
        >
          <unicon name="plus-circle" />
        </button>
      </div>
      <ul class="flex flex-col items-center">
        <li
          class="pl-2 w-full bg-transparent text-gray-900 rounded flex items-center focus-within:outline-none"
          v-for="i in Object.keys(list).sort((a, b) => {
            const nameA = productOrRecipeNameById(a) || ''
            const nameB = productOrRecipeNameById(b) || ''
            return nameA.toLowerCase().localeCompare(nameB.toLowerCase())
          })"
          :key="i"
        >
          <p class="w-full text-left truncate">
            {{ list[i] }}
            <span class="text-gray-800 font-extrabold text-base">
              {{ '  x  ' }}
            </span>
            {{ `${productOrRecipeNameById(i)}` }}
          </p>
          <button
            v-if="!readonly"
            class="ml-2 p-2 h-10 w-12 flex items-center justify-center text-base focus:outline-none focus:shadow-outline text-gray-600 hover:text-gray-900 bg-transparent hover:bg-gray-200 rounded-full"
            @click.prevent="remove(i)"
          >
            <unicon name="minus-circle" />
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ListIngredients',
  props: {
    label: {
      type: String,
      required: false,
      default() {
        return ''
      }
    },
    placeholder: {
      type: [String, Number, Boolean],
      required: false,
      default() {
        return ''
      }
    },
    list: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    },
    validationType: {
      type: String,
      required: false,
      default() {
        return 'email'
      }
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      newAmount: null,
      newIngredient: null
    }
  },
  computed: {
    ...mapGetters('storeModule/products', ['productIdsActive', 'products']),
    ...mapGetters('recipes', ['recipeIds', 'recipes']),
    ...mapGetters('storeModule', ['productOrRecipeNameById'])
  },
  methods: {
    add({ newIngredient, newAmount }) {
      if (!newIngredient || Object.keys(this.list).includes(newIngredient))
        return

      // console.log(this.validationType, validateEmail(i), validatePhone(i))
      // if (this.validationType === 'email' && !validateEmail(i)) return
      // if (this.validationType === 'phone' && !validatePhone(i)) return
      this.$emit('add', { newIngredient, newAmount: Number(newAmount) })
      this.newAmount = null
      this.newIngredient = null
      this.$nextTick(() => this.$refs.select.focus())
    },
    remove(i) {
      this.$refs.select.focus()
      this.$emit('remove', i)
    },
    focus(i) {
      console.log(i, this.$refs)
      this.$nextTick(() => this.$refs[i].focus())
    }
  }
}
</script>
